module.exports = __webpack_public_path__ + "static/aman-cedb2e98b67026444ce5a661e189446a.png";